/* ============================================================
   UNIFIED SITE HEADER JS
   ============================================================ */
(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', function () {
    var wrapper = document.getElementById('siteHeaderWrapper');
    var hamburger = document.getElementById('navHamburger');
    var nav = document.getElementById('mainNav');
    var overlay = document.getElementById('navOverlay');
    var triggers = nav ? nav.querySelectorAll('.site-nav__link--trigger') : [];
    var body = document.body;

    if (!wrapper) return;

    var headerMode = wrapper.getAttribute('data-header-mode') || 'solid';
    var hero = document.querySelector('.hero');

    function setHeaderState(state) {
      if (wrapper.classList.contains(state)) return;
      wrapper.classList.remove('is-hero', 'is-hidden', 'is-pinned');
      wrapper.classList.add(state);
    }

    function initHeaderScrollBehavior() {
      if (headerMode !== 'home-hero' || !hero) {
        setHeaderState('is-pinned');
        wrapper.classList.add('scrolled');
        return;
      }

      var ticking = false;
      var heroBottomAbs = 0;
      var TOP_THRESHOLD = 50;

      function recalcHero() {
        var rect = hero.getBoundingClientRect();
        heroBottomAbs = window.scrollY + rect.bottom;
      }

      function updateHeader() {
        ticking = false;

        if (body.classList.contains('nav-open')) return;

        var scrollY = window.scrollY || window.pageYOffset;

        if (scrollY <= TOP_THRESHOLD) {
          setHeaderState('is-hero');
          wrapper.classList.remove('scrolled');
          return;
        }

        if (scrollY >= heroBottomAbs - 80) {
          setHeaderState('is-pinned');
          wrapper.classList.add('scrolled');
          return;
        }

        setHeaderState('is-hidden');
        wrapper.classList.remove('scrolled');
      }

      function requestUpdate() {
        if (!ticking) {
          ticking = true;
          window.requestAnimationFrame(updateHeader);
        }
      }

      recalcHero();
      updateHeader();

      window.addEventListener('scroll', requestUpdate, { passive: true });
      window.addEventListener('resize', function () {
        recalcHero();
        requestUpdate();
      });

      window.addEventListener('load', function () {
        recalcHero();
        updateHeader();
      });

      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(function () {
          recalcHero();
          updateHeader();
        });
      }
    }

    function initMobileNav() {
      if (!nav || !hamburger) return;

      function openNav() {
        nav.classList.add('is-open');
        hamburger.classList.add('is-active');
        body.classList.add('nav-open');
        hamburger.setAttribute('aria-expanded', 'true');

        if (overlay) {
          overlay.classList.add('is-visible');
          overlay.setAttribute('aria-hidden', 'false');
        }

        body.style.overflow = 'hidden';
      }

      function closeNav() {
        nav.classList.remove('is-open');
        hamburger.classList.remove('is-active');
        body.classList.remove('nav-open');
        hamburger.setAttribute('aria-expanded', 'false');

        if (overlay) {
          overlay.classList.remove('is-visible');
          overlay.setAttribute('aria-hidden', 'true');
        }

        body.style.overflow = '';

        nav.querySelectorAll('.site-nav__item--has-drop.is-open').forEach(function (item) {
          item.classList.remove('is-open');
          var btn = item.querySelector('.site-nav__link--trigger');
          if (btn) btn.setAttribute('aria-expanded', 'false');
        });
      }

      hamburger.addEventListener('click', function () {
        if (nav.classList.contains('is-open')) {
          closeNav();
        } else {
          openNav();
        }
      });

      if (overlay) {
        overlay.addEventListener('click', closeNav);
      }

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && nav.classList.contains('is-open')) {
          closeNav();
        }
      });

      triggers.forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          if (window.innerWidth > 900) return;

          e.preventDefault();

          var item = btn.closest('.site-nav__item--has-drop');
          var isOpen = item.classList.contains('is-open');

          nav.querySelectorAll('.site-nav__item--has-drop.is-open').forEach(function (sibling) {
            if (sibling !== item) {
              sibling.classList.remove('is-open');
              var sibBtn = sibling.querySelector('.site-nav__link--trigger');
              if (sibBtn) sibBtn.setAttribute('aria-expanded', 'false');
            }
          });

          item.classList.toggle('is-open', !isOpen);
          btn.setAttribute('aria-expanded', String(!isOpen));
        });
      });

      window.addEventListener('resize', function () {
        if (window.innerWidth > 900) {
          closeNav();
        }
      });
    }

    initHeaderScrollBehavior();
    initMobileNav();
  });
})();
/* ============================================================
   END UNIFIED SITE HEADER JS
   ============================================================ */


(function () {
      const bg = document.getElementById('heroBg');
      if (!bg) return;

      // Disable parallax for reduced motion users
      const prefersReduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (prefersReduced) return;

      // Subtle parallax: move background slightly as user scrolls.
      // Kept tiny on purpose to maintain a premium, not "gimmicky" feel.
      let ticking = false;

      function update() {
        ticking = false;

        const hero = bg.parentElement; // .hero
        const rect = hero.getBoundingClientRect();
        const vh = window.innerHeight || document.documentElement.clientHeight;

        // Only compute while hero is in view
        if (rect.bottom < 0 || rect.top > vh) return;

        // progress: 0 (top aligned) -> 1 (scrolled past)
        const progress = Math.min(1, Math.max(0, (vh - rect.top) / (vh + rect.height)));

        // Translate and scale very subtly
        const translateY = (progress - 0.5) * 18; // -9px..+9px approx
        const scale = 1.04 + progress * 0.02;     // 1.04..1.06

        bg.style.transform = `translate3d(0, ${translateY.toFixed(2)}px, 0) scale(${scale.toFixed(3)})`;
      }

      function onScroll() {
        if (!ticking) {
          ticking = true;
          window.requestAnimationFrame(update);
        }
      }

      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll);
      update();

      // If video can't play, hide it so fallback image is cleanly visible.
      const video = document.querySelector('.hero__video');
      if (video) {
        video.addEventListener('error', () => {
          video.style.display = 'none';
        });

        // Some browsers block autoplay in edge cases; if play fails, hide video.
        const playAttempt = video.play();
        if (playAttempt && typeof playAttempt.catch === 'function') {
          playAttempt.catch(() => {
            video.style.display = 'none';
          });
        }
      }
    })();


  //Homepage slider
  {
    // --- Splide: Tiffany-style infinite loop + custom prev/next + loop-friendly progress ---
// Assumes these exist in your HTML:
// #fiveColSplide, #splidePrev, #splideNext, #splideProgressBar
//Homepage slider
document.addEventListener('DOMContentLoaded', () => {
  const root = document.querySelector('[id^="fiveColSplide"]');
  if (!root || typeof Splide === 'undefined') return;

  const sectionId = root.id.replace('fiveColSplide-', '');
  const prevBtn = document.getElementById('splidePrev-' + sectionId);
  const nextBtn = document.getElementById('splideNext-' + sectionId);
  const bar = document.getElementById('splideProgressBar-' + sectionId);
  const progressWrap = bar?.parentElement;

  const splide = new Splide(root, {
    type: 'loop',
    perPage: 5,
    perMove: 3,
    gap: '16px',
    pagination: false,
    arrows: false,
    speed: 800,
    easing: 'cubic-bezier(.4,0,.2,1)',
    drag: true,
    snap: true,
    waitForTransition: false,
    breakpoints: {
      1200: { perPage: 4 },
      980:  { perPage: 3 },
      700:  { perPage: 2 },
      480:  { perPage: 1 },
    },
  });

  if (prevBtn) prevBtn.addEventListener('click', () => splide.go('<'));
  if (nextBtn) nextBtn.addEventListener('click', () => splide.go('>'));

  function updateProgress() {
    if (!bar || !progressWrap) return;
    const total = splide.length;
    if (total <= 1) {
      bar.style.width = '100%';
      progressWrap.setAttribute('aria-valuenow', '100');
      return;
    }
    const idx = ((splide.index % total) + total) % total;
    const pct = Math.round((idx / (total - 1)) * 100);
    bar.style.width = pct + '%';
    progressWrap.setAttribute('aria-valuenow', String(pct));
  }

  splide.on('mounted move resized updated', updateProgress);
  splide.mount();
});

}

{
  document.addEventListener('DOMContentLoaded', function () {
  new Splide('.testimonial-slider', {
    type: 'slide',
    perPage: 1,
    perMove: 1,
    arrows: false,
    pagination: true,
    rewind: true,
    speed: 800,
    gap: '0px',
    autoplay: true,
  interval: 4000,
  pauseOnHover: true,
  pauseOnFocus: true
  }).mount();
});
}

/* ============================================================
   SEARCH OVERLAY
   ============================================================ */
{
(function () {
  'use strict';

  var MIN_CHARS     = 3;
  var DEBOUNCE_MS   = 280;
  var debounceTimer = null;
  var lastQuery     = '';

  var toggle  = document.getElementById('searchToggle');
  var overlay = document.getElementById('searchOverlay');
  var backdrop= document.getElementById('searchBackdrop');
  var close   = document.getElementById('searchClose');
  var input   = document.getElementById('searchInput');
  var clear   = document.getElementById('searchClear');
  var status  = document.getElementById('searchStatus');
  var results = document.getElementById('searchResults');

  if (!toggle || !overlay || !input) return;

  /* ---- Open / Close ---- */
  function openSearch() {
    overlay.classList.add('is-open');
    overlay.setAttribute('aria-hidden', 'false');
    toggle.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
    setTimeout(function () { input.focus(); }, 50);
  }

  function closeSearch() {
    overlay.classList.remove('is-open');
    overlay.setAttribute('aria-hidden', 'true');
    toggle.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  }

  toggle.addEventListener('click', openSearch);
  close.addEventListener('click', closeSearch);
  backdrop.addEventListener('click', closeSearch);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && overlay.classList.contains('is-open')) {
      closeSearch();
    }
  });

  /* ---- Clear button ---- */
  input.addEventListener('input', function () {
    var val = input.value;
    clear.hidden = val.length === 0;
    handleInput(val);
  });

  clear.addEventListener('click', function () {
    input.value = '';
    clear.hidden = true;
    input.focus();
    resetResults();
  });

  /* ---- Input handler with debounce ---- */
  function handleInput(val) {
    var query = val.trim();

    clearTimeout(debounceTimer);

    if (query.length < MIN_CHARS) {
      resetResults();
      if (query.length > 0) {
        status.textContent = 'Keep typing… (' + query.length + '/' + MIN_CHARS + ' characters)';
      } else {
        status.textContent = '';
      }
      return;
    }

    if (query === lastQuery) return;

    status.textContent = 'Searching…';
    results.innerHTML  = '';

    debounceTimer = setTimeout(function () {
      fetchResults(query);
    }, DEBOUNCE_MS);
  }

  /* ---- Reset state ---- */
  function resetResults() {
    lastQuery          = '';
    results.innerHTML  = '';
    status.textContent = '';
  }

  /* ---- Shopify Predictive Search API ---- */
  function fetchResults(query) {
    lastQuery = query;

    /*
      fields=title,variants.sku ensures both title and SKU are searched.
      type=product limits to products only.
    */
    var url = '/search/suggest.json'
      + '?q=' + encodeURIComponent(query)
      + '&resources[type]=product'
      + '&resources[limit]=8'
      + '&resources[options][fields]=title,variants.sku'
      + '&resources[options][unavailable_products]=last';

    fetch(url)
      .then(function (res) {
        if (!res.ok) throw new Error('Search failed');
        return res.json();
      })
      .then(function (data) {
        var items = data.resources && data.resources.results && data.resources.results.products
          ? data.resources.results.products
          : [];
        renderResults(items, query);
      })
      .catch(function () {
        status.textContent = 'Something went wrong. Please try again.';
        results.innerHTML  = '';
      });
  }

  /* ---- Render results ---- */
  function renderResults(items, query) {
    results.innerHTML = '';

    if (items.length === 0) {
      status.textContent = '';
      results.innerHTML  = '<div class="search-overlay__no-results">'
        + '<p>No results for &ldquo;' + escapeHtml(query) + '&rdquo;</p>'
        + '<span>Try a different search term or browse our collections.</span>'
        + '</div>';
      return;
    }

    status.textContent = items.length + ' result' + (items.length !== 1 ? 's' : '') + ' for "' + escapeHtml(query) + '"';

    items.forEach(function (product) {
      var card = document.createElement('a');
      card.className  = 'search-result-card';
      card.href       = product.url;
      card.setAttribute('role', 'listitem');

      /* Image */
      var imgHtml = product.featured_image && product.featured_image.url
        ? '<img src="' + product.featured_image.url + '" alt="' + escapeHtml(product.title) + '" class="search-result-card__image" loading="lazy">'
        : '<div class="search-result-card__no-image">No image</div>';

      /* Price */
      var priceHtml = product.price
        ? '<p class="search-result-card__price">' + formatMoney(product.price) + '</p>'
        : '';

      card.innerHTML = '<div class="search-result-card__image-wrap">' + imgHtml + '</div>'
        + '<div class="search-result-card__info">'
        + '<p class="search-result-card__title">' + escapeHtml(product.title) + '</p>'
        + priceHtml
        + '</div>';

      results.appendChild(card);
    });
  }

  /* ---- Helpers ---- */
  function escapeHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function formatMoney(price) {
    var amount = parseFloat(price).toFixed(2);
    return '€' + amount.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

})();
}
/* ============================================================
   END SEARCH OVERLAY
   ============================================================ */

/* ============================================================
   CART BADGE — refresh count on page load
   ============================================================ */
(function () {
  'use strict';

  window.updateCartCount = function (n) {
    var badge = document.querySelector('.cart-count');
    if (!badge) return;
    badge.textContent = n > 0 ? (n > 99 ? '99+' : String(n)) : '';
    badge.setAttribute('aria-label', n + ' item' + (n !== 1 ? 's' : '') + ' in cart');
  };

  document.addEventListener('DOMContentLoaded', function () {
    fetch('/cart.js')
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        window.updateCartCount(cart.item_count);
      })
      .catch(function () {});
  });

})();
/* ============================================================
   END CART BADGE
   ============================================================ */


/* ============================================================
   CART DISCOUNT CODE + FREE GIFT QUALIFIER
   ============================================================ */
(function () {
  'use strict';

  var FREE_GIFT_CODE       = 'LISA15';
  var FREE_GIFT_THRESHOLD  = 30000;   /* €300 in cents */
  var FREE_GIFT_VARIANT_ID = '57307134198104';
  var FREE_GIFT_ADD_URL    = '/cart/add?id=' + FREE_GIFT_VARIANT_ID + '&quantity=1&return_to=/cart';

  document.addEventListener('DOMContentLoaded', function () {
    var input = document.getElementById('cartDiscountInput');
    var btn   = document.getElementById('cartDiscountBtn');
    var msg   = document.getElementById('cartDiscountMsg');

    if (!input || !btn || !msg) return;

    function setMsg(html, type) {
      msg.innerHTML = html;
      msg.className = 'cart-discount__msg cart-discount__msg--' + type;
    }

    /* Re-show gift message after page reload */
    if (sessionStorage.getItem('ddi_gift_qualified') === '1') {
      sessionStorage.removeItem('ddi_gift_qualified');
      setMsg(
        '🎁 You qualify for a free gift! ' +
        '<a href="' + FREE_GIFT_ADD_URL + '" class="cart-discount__gift-link">Click here to add it to your cart</a>',
        'gift'
      );
    }

    function checkFreeGift(cart, isLisa15Code) {
      if (!isLisa15Code) return;

      var discounts = cart.cart_level_discount_applications || [];
      var lisa15Active = discounts.some(function (d) {
        return d.title && d.title.toUpperCase() === FREE_GIFT_CODE;
      });
      if (!lisa15Active) return;

      if (cart.total_price >= FREE_GIFT_THRESHOLD) {
        sessionStorage.setItem('ddi_gift_qualified', '1');
        setMsg(
          '🎁 You qualify for a free gift! ' +
          '<a href="' + FREE_GIFT_ADD_URL + '" class="cart-discount__gift-link">Click here to add it to your cart</a>',
          'gift'
        );
      }
    }

    btn.addEventListener('click', function () {
      var code = input.value.trim();
      if (!code) {
        setMsg('Please enter a discount code.', 'error');
        return;
      }

      var isLisa15 = code.toUpperCase() === FREE_GIFT_CODE;

      btn.disabled    = true;
      btn.textContent = 'Applying…';
      setMsg('', '');

      fetch('/discount/' + encodeURIComponent(code) + '?redirect=/cart', {
        method: 'GET',
        redirect: 'follow'
      })
      .then(function () { return fetch('/cart.js'); })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        btn.disabled    = false;
        btn.textContent = 'Apply';

        /* Shopify validates discount at checkout — we trust the redirect worked.
           cart_level_discount_applications is unreliable on non-Plus plans. */
        if (isLisa15) {
          setMsg('Discount applied successfully.', 'success');
          checkFreeGift(cart, true);
          setTimeout(function () { window.location.reload(); }, 1000);
        } else {
          setMsg('Discount code applied. Your discount will appear at checkout.', 'success');
          setTimeout(function () { window.location.reload(); }, 1500);
        }
      })
      .catch(function () {
        setMsg('Something went wrong. Please try again.', 'error');
        btn.disabled    = false;
        btn.textContent = 'Apply';
      });
    });

    /* Enter key submits */
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') btn.click();
    });
  });

})();
/* ============================================================
   END CART DISCOUNT CODE + FREE GIFT QUALIFIER
   ============================================================ */